var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9366",
    "data-name": "Ellipse 9366",
    cx: 58,
    cy: 58,
    r: 58,
    transform: "translate(160 193)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-160 -193)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9365",
    "data-name": "Ellipse 9365",
    cx: 58,
    cy: 58,
    r: 58,
    transform: "translate(160 193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(176 211.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M0,83V72.626c0-11.412,18.675-20.75,41.5-20.75S83,61.214,83,72.626V83l-42.94,41.786ZM20.75,20.751A20.75,20.75,0,1,1,41.5,41.5,20.75,20.75,0,0,1,20.75,20.751Z",
    transform: "translate(0 -0.002)",
    fill: "#e5f3fe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/profilePic.a66260ff5fb2311f7040f2a407564d67.svg";
export { ForwardRef as ReactComponent };